import { useState, useEffect } from "react";
import urls from "../../../Utils/urls";
import axios from "axios";
import { loadingTypes } from "../../../Utils/constant";

const useLoanDetails = (loanId) => {
  const [data, setData] = useState({
    kpi: [],
    account_details: [],
    overdue_nextdue: [],
    property_details: [],
    instruction_set_details: [],
    account_holder: [],
    insurance_details: [],
  });

  const [transactionData, setTransactionData] = useState([]);
  const [transactionStatus, setTransactionStatus] = useState(loadingTypes.idle);
  const [status, setStatus] = useState(loadingTypes.idle);

  useEffect(() => {
    async function getLoanDetails() {
      setStatus(loadingTypes.loading);
      try {
        const res = await axios.get(urls.borrower.getNewLoanDetails(loanId), {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
          },
        });
        if (res?.data?.items) {
          const data = transformData(res?.data?.items);
          setData(data);
          setStatus(loadingTypes.fulfilled);
        }
      } catch (error) {
        console.error(error);
        setStatus(loadingTypes.failed);
      }
    }
    getLoanDetails();
  }, [loanId]);

  useEffect(() => {
    async function getRecentTransactions() {
      try {
        setTransactionStatus(loadingTypes.loading);
        const res = await axios.get(
          urls.borrower.getRecentTransactions(loanId),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
            },
          }
        );

        if (res?.data?.items) {
          // console.log("response ", res.data.items);

          setTransactionData(res.data.items);
          setTransactionStatus(loadingTypes.fulfilled);
        }
      } catch (error) {
        console.error(error);
      }
    }
    getRecentTransactions();
  }, [loanId]);

  return { data, transactionData, transactionStatus, status };
};

export default useLoanDetails;

function transformData(data) {
  const kpiData = data[0]?.details?.KPI?.map((item) => ({
    "Total Loan Amount": item.total_loan_amount,
    Disbursed: item.disbursed,
    Outstanding: item.outstanding,
    "Next Payment": item.next_payment,
  }));
  const account_detailsData = data[0]?.details?.account_details;
  const overdue_nextdueData = data[0]?.details?.other_details;
  const property_detailsData = data[0]?.details?.property_details;
  const instruction_set_detailsData = data[0]?.details?.instruction_set_details;
  const account_holderData = data[0]?.details?.account_holder;
  const insurance_detailsData = data[0]?.details?.insurance_details;
  return {
    kpi: kpiData,
    account_details: account_detailsData,
    overdue_nextdue: overdue_nextdueData,
    property_details: property_detailsData,
    instruction_set_details: instruction_set_detailsData,
    account_holder: account_holderData,
    insurance_details: insurance_detailsData,
  };
}
